export enum Sections {
  HERO = 'hero',
  EASYBUY = 'easy-buy',
  ADVANTAGES = 'advantages',
  SIXINTIX = 'six-in-tix',
}
